import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const painPoints = ['Llegás a la clase sin saber exactamente qué ejercicios vas a dar hoy', 'Tus alumnos no progresan porque no tenés una estructura clara de nivel a nivel', 'El 40% abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos 10 o 15 ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde', 'Tenés alumnos con distintas patologías juntos y la clase se convierte en un caos', 'Fin de mes y los alumnos se van sin avisar porque la comunicación es inconsistente'];
export function PainPoints() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-162">
          <h2 className="text-2xl md:text-3xl font-bold text-navy-900 mb-4" data-id="element-163">
            Si trabajás con adultos mayores en Argentina, esto te va a sonar
            familiar:
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4 mb-6 md:mb-12" data-id="element-164">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="flex items-start gap-4 bg-red-50 p-4 rounded-lg border border-red-100" data-id="element-165">
              <div className="mt-0.5 bg-red-100 p-1 rounded-full text-danger shrink-0" data-id="element-166">
                <X size={20} strokeWidth={3} data-id="element-167" />
              </div>
              <p className="text-navy-800 font-medium" data-id="element-168">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-169">
          <h3 className="font-display text-4xl md:text-5xl text-danger uppercase tracking-wide" data-id="element-170">
            ¿Cuántas clases más vas a improvisar con tus alumnos mayores?
          </h3>
        </motion.div>
      </div>
    </section>;
}